const URL_PROTOCOL_PATTERNS = {
  http: /^http:\/\//,
  https: /^https:\/\//,
  ftp: /^ftp:\/\//,
  mailto: /^mailto:/,
};

export const isValidUrlProtocol = ({
  input,
  allowProtocols = {
    http: true,
    https: true,
  },
}: {
  input: string;
  allowProtocols?: Partial<Record<keyof typeof URL_PROTOCOL_PATTERNS, boolean>>;
}) => {
  const regExp = new RegExp(
    Object.entries(URL_PROTOCOL_PATTERNS)
      .filter(
        ([key]) => allowProtocols[key as keyof typeof URL_PROTOCOL_PATTERNS],
      )
      .map(([_, pattern]) => pattern.source)
      .join('|'),
  );
  return regExp.test(input);
};
